import { render, staticRenderFns } from "./ReviewAuditAction.vue?vue&type=template&id=78936c70&scoped=true&"
import script from "./ReviewAuditAction.vue?vue&type=script&lang=ts&"
export * from "./ReviewAuditAction.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewAuditAction.vue?vue&type=style&index=0&id=78936c70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78936c70",
  null
  
)

export default component.exports